import { CoreIcon } from '../core-icon';
import passCircleColorSVG from '../../assets/icons/pass-circle-color.svg';
import type { IconProps } from '../core-icon';

export const PassCircleColorIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={passCircleColorSVG} {...props} />;
};
